import React, { PureComponent } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import Dashboard from '../Dashboard'

class App extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/dashboard">
          <Dashboard template='dashboard' />
        </Route>
      </Switch>
    );
  }
}

export default withRouter(App);